import { Plugin } from '@segment/analytics-next'
import { EVENT_NAME as EN } from '../../constants/EventName'
import SessionStorageService from '../../../../utils/SessionStorageService'
import { getUtmPayload } from '../../../segment'

const SegmentInjectCampaignPlugin: Plugin = {
  name: 'SegmentInjectCampaignPlugin',
  type: 'enrichment',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: ctx => {
    if (ctx.event.type === 'identify') {
      return ctx
    }

    const includedEventNames = [
      EN.USER_LOGGED_IN,
      EN.USER_LOGGED_OUT,
      EN.SEARCH_BAR_VIEW,
      EN.SEARCH_STARTED,
    ]
    if (!includedEventNames.includes(ctx.event.event ?? '')) {
      return ctx
    }

    const utmQuery = SessionStorageService.getItem('utm_payload')
    const data = utmQuery ? JSON.parse(utmQuery) : {}
    const utmPayload = getUtmPayload(data)

    ctx.updateEvent(
      'context.campaign.content',
      utmPayload['utm content' as keyof typeof utmPayload]
    )
    ctx.updateEvent(
      'context.campaign.medium',
      utmPayload['utm medium' as keyof typeof utmPayload]
    )
    ctx.updateEvent(
      'context.campaign.name',
      utmPayload['utm campaign' as keyof typeof utmPayload]
    )
    ctx.updateEvent(
      'context.campaign.source',
      utmPayload['utm source' as keyof typeof utmPayload]
    )
    ctx.updateEvent(
      'context.campaign.term',
      utmPayload['utm term' as keyof typeof utmPayload]
    )

    return ctx
  },
}

export default SegmentInjectCampaignPlugin
